module.exports = __webpack_public_path__ + "com_index_2fig.png?eea803fde3d971802d386a4c345a9067";


//////////////////
// WEBPACK FOOTER
// ./static/images/com_index_2fig.png
// module id = 122
// module chunks = 0